<script setup lang="ts">
import type { BaseValidation } from "@vuelidate/core";

defineProps<{ validation: Pick<BaseValidation, "$errors"> }>();
</script>

<template>
  <div v-if="validation.$errors.length" class="invalid-feedback d-block">
    <div v-for="error in validation.$errors" :key="error.$uid">
      {{ error.$message }}
    </div>
  </div>
</template>
